export class Funcoes {
    formatPhone = phone => phone.replace(/\D/g, '').replace(/(\d{2})(\d)(\d{4})(\d{4})$/, '($1)$2$3-$4')
    formatCPF = cpf => cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4")
    formatCNPJ = cnpj => cnpj.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5")
    ptBR = {
        firstDayOfWeek: 0,
        dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
        dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
        monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        today: 'Hoje',
        clear: 'Limpar'
    };
    IsNullEmpty(strValue) {

        console.log(strValue);
        // Teste se strValue está vazio ou é Nenhum
        if (strValue) {
            return null;
        }
        // Teste se strValue está vazio, mas não nenhum
        if (strValue === "") {
            return null;
        }
        console.log(strValue);
        return strValue;
    }
    getString = value => (value || "").toString();

    Origens =
        [{ nome: "Receber" },
        { nome: "Pagar" }];

        Periodos =
        [
        { nome: "3 Meses", cod: "90" },
        { nome: "6 Meses", cod: "180" },
        { nome: "9 Meses", cod: "270" },
        { nome: "1 Ano", cod: "365" },
        { nome: "Janeiro", cod: "01" },
        { nome: "Fevereiro", cod: "02" },
        { nome: "Março", cod: "03" },
        { nome: "Abril", cod: "04" },
        { nome: "Maio", cod: "05" },
        { nome: "Junho", cod: "06" },
        { nome: "Julho", cod: "07" },
        { nome: "Agosto", cod: "08" },
        { nome: "Setembro", cod: "09" },
        { nome: "Outubro", cod: "10" },
        { nome: "Novembro", cod: "11" },
        { nome: "Dezembro", cod: "12"}
    ];
        
    ListaEstados =
        [{ nome: null, codigo: '' },
        { nome: "AC", codigo: '' },
        { nome: "AL", codigo: '' },
        { nome: "AP", codigo: '' },
        { nome: "AM", codigo: '' },
        { nome: "BA", codigo: '' },
        { nome: "CE", codigo: '' },
        { nome: "DF", codigo: '' },
        { nome: "ES", codigo: '' },
        { nome: "GO", codigo: '' },
        { nome: "MA", codigo: '' },
        { nome: "MT", codigo: '' },
        { nome: "MS", codigo: '' },
        { nome: "MG", codigo: '' },
        { nome: "PA", codigo: '' },
        { nome: "PB", codigo: '' },
        { nome: "PR", codigo: '' },
        { nome: "PE", codigo: '' },
        { nome: "PI", codigo: '' },
        { nome: "RJ", codigo: '' },
        { nome: "RN", codigo: '' },
        { nome: "RS", codigo: '' },
        { nome: "RO", codigo: '' },
        { nome: "RR", codigo: '' },
        { nome: "SC", codigo: '' },
        { nome: "SP", codigo: '' },
        { nome: "SE", codigo: '' },
        { nome: "TO", codigo: '' }
        ];

}

export class Estados {
    nome: string
    codigo: string
}

export class Periodos {
    nome: string
    cod: string
}